<template>
  <v-row dense>
    <v-col>
      <v-text-field
        v-model="form.name"
        name="name"
        :label="$t('CONTRACTS.NAME')"
        :readonly="readonly"
        counter="255"
        :error-messages="errors.name"
        :rules="getRulesByName('textLine')"
        @input="updateValue('name', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-select
        v-model="form.service_id"
        name="service_id"
        item-text="title"
        item-value="id"
        :items="services"
        :readonly="readonly"
        :label="`${$t('ABO_SERVICES.ITEM')} *`"
        :rules="getRulesByName('service_id')"
        :error-messages="errors.service_id"
        clearable
        @change="updateValue('service_id', $event)"
      />
    </v-col>
    <v-col cols="12">
      <contract-form
        v-model="form"
        :errors="errors"
        :building-complex-id="buildingComplexId"
        :readonly="readonly"
        v-bind="$attrs"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty, textLine } from '@/modules/_global/variables/rules';
import { mapActions } from 'vuex';
import { ACTIVE } from '@/modules/abo_services/common/statuses';
import ContractForm from '@/modules/building_complexes_contracts/components/forms/ContractForm';

export default {
  name: 'CreateContractForm',

  components: {
    ContractForm
  },

  mixins: [formEditable],

  props: ContractForm.props,

  data() {
    return {
      form: {},
      rules: {
        service_id: [notEmpty],
        name: textLine
      },
      services: []
    };
  },

  mounted() {
    this.getServicesFilterList({ status: ACTIVE }).then(({ data }) => {
      this.services = data.data;
    });
  },

  methods: {
    ...mapActions('contracts', ['getServicesFilterList'])
  }
};
</script>

<style scoped></style>
